import { render } from "./workflows.vue?vue&type=template&id=3740d632&scoped=true&ts=true"
import script from "./workflows.vue?vue&type=script&lang=ts"
export * from "./workflows.vue?vue&type=script&lang=ts"

import "./workflows.vue?vue&type=style&index=0&id=3740d632&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3740d632"]])

export default __exports__